import React from 'react'

export default function Input({name,label,type,value,onChange}) {
    return (
        <div className="mb-6">
        <label htmlFor={name} className="block mb-2 text-sm ">{label}</label>
        <input type={type}
         name={name}
         value={value}
         onChange={onChange}
         className="w-full px-3 py-3 text-sm  border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
        />
    </div>
    )
}
